import React, { Component } from 'react';
import Recaptcha from 'react-recaptcha'
import { Form, Modal } from 'antd'

import InputCustom from '../../components/default/InputCustom'
import LinkCustom from '../../components/default/LinkCustom'
import ButtonCustom from '../../components/default/ButtonCustom'

import { connect } from 'react-redux'
import { userLogin } from '../../actions/auth'

class Login extends Component {
    state = {
        email: "",
        password: "",
        isVerify: false,
    }

    onChange = (event) => {
        const name = event.target.name
        this.setState({
            [name]: event.target.value
        })
    }

    onVerify = (event) => {
        this.setState( { isVerify: !this.state.isVerify } )
        //need to send key to verify on server
        // console.log(event)
    }

    callback = (e) => {}
    

    handleSubmit = async (e) => {
        e.preventDefault()
        const { email, password, isVerify } = this.state

        if(isVerify === false){
            Modal.error({
                title: 'Verifying Humanity',
                content: 'please verify your humanity',
            })
            return false
        }

        this.props.userLogin({ email, password })
    }

    render() {
        return (
            <Form onSubmit={this.handleSubmit}>
                <div className="login-section-wrap">
                    <div className="login-section">
                        <div className="login-section-title gapb-32">เข้าสู่ระบบ</div>
                        <InputCustom
                            label="อีเมล"
                            labelColor="65"
                            size="large"
                            type="text"
                            required
                            placeholder="อีเมล"
                            marginBottom="16"
                            name="email"
                            onChange={this.onChange}
                        />
                        <InputCustom
                            label="รหัสผ่าน"
                            labelColor="65"
                            size="large"
                            type="password"
                            required
                            placeholder="รหัสผ่าน"
                            marginBottom="16"
                            name="password"
                            onChange={this.onChange}
                        />
                        <div className="textAlign-right is-100 gapb-24">
                            <LinkCustom label="ลืมรหัสผ่าน?" link="/password/forgot" />
                        </div>
                        <div className="gapb-32">
                            <Recaptcha
                                className="recaptcha-wrap"
                                sitekey="6LcWonkUAAAAANWpCP2254xnRFxTvgw17pXh1cIN"
                                render="explicit"
                                onloadCallback={this.callback}
                                verifyCallback={this.onVerify}
                                size="normal"
                            />
                        </div>
                        <div className="gapb-24">
                            <ButtonCustom
                                borderRadius="4"
                                color="blue"
                                label="เข้าสู่ระบบ"
                                fontSize={14}
                                fontWeight="Bold"
                                size="large"
                                htmlType="submit"
                            />
                        </div>
                        <div className="login-info textAlign-center">ยังไม่มีบัญชีผู้ใช้? <LinkCustom label="สมัครสมาชิก?" link="/register" /></div>
                    </div>
                </div>
            </Form>
        );
    }
}

const mapStateToProps = (state) => {
    return{
        auth: state.auth,
        user: state.user
    }
}

const mapDispatchToProps = {
    userLogin
}

export default connect(mapStateToProps,mapDispatchToProps)(Login)
